module.exports = __webpack_public_path__ + "static/media/desktop13.01008ea6.png";